<div *ngIf="this.isLoading" class="progress-spinner">
	<p-progressSpinner></p-progressSpinner>
</div>

<div class="card">
	<div class="p-grid">
		<div class="col-3">
			<p-inputGroup>
				<input [(ngModel)]="searchTerm" pInputText placeholder="Task Search"
							 type="text"/>
				<button (click)="search()" icon="pi pi-search" iconPos="right" label="Search" pButton type="button"></button>
			</p-inputGroup>
			<p class="pt-2 search-text">Enter a Form field input, such as "Concierge", or an employee's Last Name, to search
				your property's Forms archives</p>
		</div>
		<div class="col-12">
			<app-day-task-table
				[taskList]="tasks"
			></app-day-task-table>
		</div>
	</div>
</div>
